<template>
  <Header />
  <!-- <BreadCrumb :valueFromParent="parentValue" /> -->
  <BreadCrumb />
  <section class="about-us">
    <!-- Page-wrapper-Start -->
    <div class="page_wrapper">
      <!-- Preloader -->
      <!-- <div id="preloader">
        <div id="loader"></div>
      </div> -->
    </div>
    <!-- Page-wrapper-End -->
  </section>
  <!-- App-Solution-Section-Start -->
  <section class="row_am app_solution_section">
    <!-- container start -->
    <div class="container">
      <!-- row start -->
      <div class="row">
        <div class="col-lg-6">
          <!-- UI content -->
          <div class="app_text">
            <div
              class="section_title"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="100"
            >
              <h2><span>Thank You </span>for getting in touch with us.</h2>
            </div>
            <p data-aos="fade-up" data-aos-duration="1500">
              We have gotten your email. We'll get back to you soon, and you
              will receive an email message shortly.
            </p>
            <a
              href="/"
              class="btn puprple_btn"
              data-aos="fade-in"
              data-aos-duration="1500"
              >Go Back Home</a
            >
          </div>
        </div>
        <div class="col-lg-6">
          <div class="app_images" data-aos="fade-in" data-aos-duration="1500">
            <img src="images/thankyou.png" alt="Thank You" />
          </div>
        </div>
      </div>
      <!-- row end -->
    </div>
    <!-- container end -->
  </section>
  <!-- App-Solution-Section-end -->

  <Newsletter />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import About from "@/components/AboutSection.vue";
import CountBox from "@/components/CountBox.vue";
import DownloadBox from "@/components/DownloadBox.vue";
import Newsletter from "@/components/NewsletterBox.vue";
import "@fortawesome/fontawesome-free/css/all.css";

import BreadCrumb from "@/components/BreadCrumb.vue";
import Footer from "@/components/FooterArea.vue";
import { ref, onMounted } from "vue";
export default {
  name: "User_Login",
  components: {
    Header,
    BreadCrumb,
    CountBox,
    About,
    DownloadBox,
    Newsletter,
    Footer,
  },
  setup() {
    // Define a reactive variable to hold the title
    const pageTitle = ref("Salt - Thank You");

    // Function to update the title
    const updateTitle = () => {
      document.title = pageTitle.value;
    };

    // Call updateTitle when component is mounted
    onMounted(() => {
      updateTitle();
    });

    return {
      pageTitle,
      updateTitle,
    };
  },
};
</script>

<style scoped>
.signup_form form span {
  color: red;
}
img {
  max-width: 100%;
}
.user_profile {
  background: #d73000;
  max-height: 100%;
  height: 100vh;
  color: #fff;
}
.user_profile .single_advisor_profile {
  font-size: 17px;
}
.single_advisor_profile {
  position: relative;

  width: 60%;
  margin-bottom: 50px;
  transition-duration: 500ms;
  z-index: 1;
  border-radius: 15px;
  box-shadow: 0 0.25rem 1rem 0 rgba(47, 91, 234, 0.125);
  /* padding: 10% 20%; */
  padding-top: 10%;
  padding-bottom: 5%;
  display: table;
  margin: auto;
  overflow: hidden;
  background: #050505;
  color: #fff;
}
.single_advisor_profile hr {
  color: #fff;
  background: #5a5a5a;
}
.single_advisor_profile .advisor_thumb {
  position: relative;
  z-index: 1;
  border-radius: 50%;
  margin: 0 auto 20px auto;
  /* padding: 30px 30px 0 30px; */
  background-color: #3f43fd;
  width: 250px;
  height: 250px;
  overflow: hidden;
}
.fas,
.fa-solid {
  font-weight: 900;
  margin-top: 8px;
  font-size: 26px;
}
.btn-area {
  margin: 25px auto 0 auto;
  width: 75%;
  position: relative;
  display: block;
}
.btn-area a:first-child {
  float: inline-start;
}
.btn-area a:last-child {
  float: inline-end;
}

.user_profile .fas {
  font-size: 13px;
}

/* .single_advisor_profile .advisor_thumb::after {
  -webkit-transition-duration: 500ms;
  transition-duration: 500ms;
  position: absolute;
  width: 150%;
  height: 80px;
  bottom: -45px;
  left: -25%;
  content: "";
  background-color: #ffffff;
  -webkit-transform: rotate(-15deg);
  transform: rotate(-15deg);
} */
.single_advisor_profile .labelName {
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 42px;
}
.single_advisor_profile .labelbox {
  display: table;
  margin: auto;
  padding-bottom: 7px;
  text-align: left;
  line-height: 42px;
}
.single_advisor_profile .labelbox .captionn {
  float: left;
  margin-right: 15px;
  font-size: 17px;
}
.single_advisor_profile .labelbox .detail {
  float: left;
  font-size: 17px;
}
.single_advisor_profile .labelbox .captionn .fas {
  font-size: 20px;
}
.single_advisor_profile:before {
  content: "";
  display: block;
  width: 190px;
  height: 300px;
  background: #fff;
  position: absolute;
  animation: rotatemagicc 0.75s cubic-bezier(0.425, 1.04, 0.47, 1.105) 1s both;
}
.single_advisor_profile:after {
  content: "";
  display: block;
  width: 190px;
  height: 300px;
  background: #fff;
  position: absolute;
  animation: rotatemagic 0.75s cubic-bezier(0.425, 1.04, 0.47, 1.105) 1s both;
}
@media only screen and (max-width: 575px) {
  .single_advisor_profile .advisor_thumb::after {
    height: 160px;
    bottom: -90px;
  }
}
.single_advisor_profile .advisor_thumb .social-info {
  position: absolute;
  z-index: 1;
  width: 100%;
  bottom: 0;
  right: 30px;
  text-align: right;
}
.single_advisor_profile .advisor_thumb .social-info a {
  font-size: 14px;
  color: #020710;
  padding: 0 5px;
}
.single_advisor_profile .advisor_thumb .social-info a:hover,
.single_advisor_profile .advisor_thumb .social-info a:focus {
  color: #3f43fd;
}
.single_advisor_profile .advisor_thumb .social-info a:last-child {
  padding-right: 0;
}
.single_advisor_profile .single_advisor_details_info {
  position: relative;
  z-index: 1;
  padding: 30px;
  text-align: right;
  -webkit-transition-duration: 500ms;
  transition-duration: 500ms;
  border-radius: 0 0 15px 15px;
  background-color: #ffffff;
}
.single_advisor_profile .single_advisor_details_info::after {
  -webkit-transition-duration: 500ms;
  transition-duration: 500ms;
  position: absolute;
  z-index: 1;
  width: 50px;
  height: 3px;
  background-color: #3f43fd;
  content: "";
  top: 12px;
  right: 30px;
}
.single_advisor_profile .single_advisor_details_info h6 {
  margin-bottom: 0.25rem;
  -webkit-transition-duration: 500ms;
  transition-duration: 500ms;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .single_advisor_profile .single_advisor_details_info h6 {
    font-size: 14px;
  }
}
.single_advisor_profile .single_advisor_details_info p {
  -webkit-transition-duration: 500ms;
  transition-duration: 500ms;
  margin-bottom: 0;
  font-size: 14px;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .single_advisor_profile .single_advisor_details_info p {
    font-size: 12px;
  }
}
.single_advisor_profile:hover .advisor_thumb::after,
.single_advisor_profile:focus .advisor_thumb::after {
  background-color: #070a57;
}
.single_advisor_profile:hover .advisor_thumb .social-info a,
.single_advisor_profile:focus .advisor_thumb .social-info a {
  color: #ffffff;
}
.single_advisor_profile:hover .advisor_thumb .social-info a:hover,
.single_advisor_profile:hover .advisor_thumb .social-info a:focus,
.single_advisor_profile:focus .advisor_thumb .social-info a:hover,
.single_advisor_profile:focus .advisor_thumb .social-info a:focus {
  color: #ffffff;
}
.single_advisor_profile:hover .single_advisor_details_info,
.single_advisor_profile:focus .single_advisor_details_info {
  background-color: #070a57;
}
.single_advisor_profile:hover .single_advisor_details_info::after,
.single_advisor_profile:focus .single_advisor_details_info::after {
  background-color: #ffffff;
}
.single_advisor_profile:hover .single_advisor_details_info h6,
.single_advisor_profile:focus .single_advisor_details_info h6 {
  color: #ffffff;
}
.single_advisor_profile:hover .single_advisor_details_info p,
.single_advisor_profile:focus .single_advisor_details_info p {
  color: #ffffff;
}
@keyframes animatop {
  0% {
    opacity: 0;
    bottom: -500px;
  }
  100% {
    opacity: 1;
    bottom: 0px;
  }
}

@keyframes animainfos {
  0% {
    bottom: 10px;
  }
  100% {
    bottom: -42px;
  }
}

@keyframes rotatemagic {
  0% {
    opacity: 0;
    transform: rotate(0deg);
    top: 0px;
    left: -30px;
  }
  100% {
    transform: rotate(-22deg);
    top: 0px;
    left: -108px;
  }
}

@keyframes rotatemagicc {
  0% {
    opacity: 0;
    transform: rotate(0deg);
    top: -30px;
    right: -30px;
  }
  100% {
    transform: rotate(-30deg);
    top: 0px;
    right: -108px;
  }
}

@media only screen and (max-width: 1199px) {
  .single_advisor_profile {
    width: 80%;
  }
}
@media only screen and (max-width: 991px) {
  .single_advisor_profile {
    width: 90%;
  }
}
@media only screen and (max-width: 767px) {
  .single_advisor_profile {
    width: 95%;
  }
}

@media only screen and (max-width: 540px) {
  .single_advisor_profile:before {
    display: none;
  }
  .single_advisor_profile:after {
    display: none;
  }
}
.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
